/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Exhaustairtemperature2Inputs */



/**
* | output |
* | --- |
* | "Exhaust air temperature" |
*
* @param {Ahu_History_Key_Exhaustairtemperature2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_exhaustairtemperature2 = /** @type {((inputs?: Ahu_History_Key_Exhaustairtemperature2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Exhaustairtemperature2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Exhaust air temperature")
	return /** @type {LocalizedString} */ ("Température air rejeté")
});
export { ahu_history_key_exhaustairtemperature2 as "ahu_history_key_exhaustAirTemperature" }